import { defineComponent as m, computed as t } from "vue";
import u from "./index10.js";
import l from "../../../csr_phone_number/ui/components/index.js";
import p from "./index11.js";
import d from "../../../country_selector/ui/components/index.js";
import { Variants as f } from "../../../country_selector/ui/types/index.js";
import b from "./index12.js";
import y from "./index13.js";
import "@ado/acs-standard-library";
import { submitInternalEvent as r } from "@ado/tracking-library";
import { TRACKING_EVENTS as o } from "../../../shared/data/tracking/types/index.js";
import { useBaseApplicationTranslation as C } from "../../../shared/libraries/local-translations/index.js";
const I = m({
  name: "Header",
  components: {
    HeaderLogo: u,
    CSRPhoneNumber: l,
    HeaderHelp: p,
    CountrySelector: d,
    HeaderAccount: b,
    HeaderSkeleton: y
  },
  props: {
    bannerStyle: {
      type: String,
      required: !0
    },
    config: {
      type: Object,
      required: !0
    },
    csr: {
      type: Object,
      required: !0
    },
    location: {
      type: Object,
      required: !0
    },
    user: {
      type: Object,
      required: !0
    },
    disableSendingSignInRequestsToOtherHosts: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const n = t(
      () => Object.keys(e.config).length === 0 || Object.keys(e.location.currentCountry).length === 0
    ), a = () => {
      r(o.HEADER_PHONE_NUMBER_CLICK);
    }, i = () => {
      r(o.HEADER_LAW_DEPOT_CLICK);
    }, s = t(() => e.bannerStyle === "SELECTION"), c = C().isLoaded;
    return {
      arePropsUnavailable: n,
      trackPhoneNumberClick: a,
      trackLogoClick: i,
      isSelectionBanner: s,
      CountryVariants: f,
      areTranslationsLoaded: c
    };
  }
});
export {
  I as default
};
//# sourceMappingURL=index6.js.map
